import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", {
  id: "form",
  class: "h40 d-flex align-items-center bg-gradient2 section-padding"
}, null, -1)
const _hoisted_2 = {
  id: "process",
  class: "bg-gray-200 section-padding-b"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-sm-8 col-lg-7" }
const _hoisted_6 = { class: "card-step card-form" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header bg-red text-white" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h6" }, " Sin importar tus respuestas, encontraremos una oferta para ti. Responde honestamente a estas preguntas ")
], -1)
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"center"},
  class: "my-5"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-fluid p-formgrid p-grid px-4" }
const _hoisted_11 = { class: "my-2 ml-0" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 3,
  class: "px-lg-5 ml-4"
}
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 5 }
const _hoisted_19 = { key: 6 }
const _hoisted_20 = { key: 7 }
const _hoisted_21 = {
  key: 1,
  class: "px-4 pb-4"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col button-card-footer" }
const _hoisted_25 = { class: "col button-card-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_TypeText = _resolveComponent("TypeText")!
  const _component_TypePhone = _resolveComponent("TypePhone")!
  const _component_TypeEmail = _resolveComponent("TypeEmail")!
  const _component_TypeSwitch = _resolveComponent("TypeSwitch")!
  const _component_TypeRadioButton = _resolveComponent("TypeRadioButton")!
  const _component_TypeYesNoButton = _resolveComponent("TypeYesNoButton")!
  const _component_TypeDropDown = _resolveComponent("TypeDropDown")!
  const _component_TypeDate = _resolveComponent("TypeDate")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_spinner, {
                      text: "Estamos procesando tu solicitud, espera un momento.",
                      color: _ctx.spinnerColor,
                      textColor: _ctx.spinnerTextColor
                    }, null, 8, ["color", "textColor"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionnaire.questions, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  (!_ctx.loading && _ctx.currentStep == item.order)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("form", _hoisted_10, [
                          _createElementVNode("h4", {
                            class: _normalizeClass(["h6 mt-4 pb-1", [index === 0 ? 'text-left' : 'text-center']])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["font-weight-bold", { contact: index === 0 }])
                            }, _toDisplayString(item.name), 3),
                            _createElementVNode("p", _hoisted_11, [
                              _createElementVNode("span", {
                                innerHTML: item.details
                              }, null, 8, _hoisted_12)
                            ])
                          ], 2),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answersKeys, (itemanswer) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "answer mb-2",
                              key: itemanswer.id
                            }, [
                              (itemanswer.component === 'text')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_TypeText, {
                                      "answer-key": itemanswer.key,
                                      label: item.name,
                                      "validation-label": "Este campo es obligatorio",
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'phone')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_TypePhone, {
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      "validation-label": `Campo incorrecto. Ingresa un número de ${_ctx.phoneLength} dígitos.`,
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      value: itemanswer.value,
                                      minLength: _ctx.phoneLength,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "validation-label", "isRequired", "isSubmitted", "value", "minLength", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'email')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(_component_TypeEmail, {
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      "validation-label": "Campo incorrecto. Ingresa un correo válido.",
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'switch' && itemanswer.key != 'privacyNotice')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_TypeSwitch, {
                                      "answer-key": itemanswer.key,
                                      label: itemanswer.name,
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "label", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'radiobutton')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_TypeRadioButton, {
                                      "answer-key": itemanswer.key,
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      catalog: itemanswer.catalog,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "isRequired", "isSubmitted", "catalog", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'yesnobutton')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_TypeYesNoButton, {
                                      "answer-key": itemanswer.key,
                                      "validation-label": "Este campo es obligatorio.",
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'dropdown')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_TypeDropDown, {
                                      "answer-key": itemanswer.key,
                                      "validation-label": "Campo incorrecto. Selecciona una opción.",
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      catalog: itemanswer.catalog,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "isRequired", "isSubmitted", "catalog", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (itemanswer.component === 'date')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_TypeDate, {
                                      "answer-key": itemanswer.key,
                                      isRequired: itemanswer.required,
                                      isSubmitted: _ctx.submitted,
                                      onGetValue: _ctx.setValue
                                    }, null, 8, ["answer-key", "isRequired", "isSubmitted", "onGetValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_Button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.to(_ctx.currentStep-1))),
                          iconPos: "left",
                          label: "Regresar",
                          icon: "fas fa-angle-double-left",
                          class: "surface-50 border-0 p-button-rounded font-weight-bold text-900"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_Button, {
                          iconPos: "right",
                          onClick: _ctx.register,
                          label: "Siguiente",
                          icon: "fas fa-angle-double-right",
                          class: "bg-yellow-500 border-yellow-500 p-button-raised p-button-rounded font-weight-bold text-900"
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}